import { NestedProperty } from "../nested-property";
var DatagridPropertyStringFilter = (function () {
    function DatagridPropertyStringFilter(prop, exact) {
        if (exact === void 0) { exact = false; }
        this.prop = prop;
        this.exact = exact;
        this.nestedProp = new NestedProperty(prop);
    }
    DatagridPropertyStringFilter.prototype.accepts = function (item, search) {
        var propValue = this.nestedProp.getPropValue(item);
        if (typeof propValue === "undefined") {
            return false;
        }
        else if (this.exact) {
            return ("" + propValue).toLowerCase() === search;
        }
        else {
            return ("" + propValue).toLowerCase().indexOf(search) >= 0;
        }
    };
    return DatagridPropertyStringFilter;
}());
export { DatagridPropertyStringFilter };
//# sourceMappingURL=datagrid-property-string-filter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/built-in/filters/datagrid-property-string-filter.js
// module id = 80
// module chunks = 4